export enum SearchResultStatus {
	Pending = 'pending',
	Results = 'results',
	Empty = 'empty',
	Error = 'error',
}

export enum SearchResultType {
	Articles = 'articles',
	Portals = 'portals',
	RequestTypes = 'requestTypes',
}

export type SearchResultStatuses = Record<SearchResultType, SearchResultStatus>;

export interface SearchQueryProps {
	cloudId: string;
	helpCenterAri: string;
	onStatus: (status: SearchResultStatus) => void;
	queryWord: string;
}
